import { Component} from '@angular/core';

@Component({
    selector: 'shtibel-main',
    templateUrl: './shtibel-main.tmpl.html'
})

export class ShtibelMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  